import type {
  UserAvatarStatusColor,
  UserAvatarType,
  UserAvatarUser,
} from "./user-avatar.type";
import type { CSSProperties } from "react";

import { getAcronym } from "@/utilities/string";

export const getUserAvatarText = (
  type: UserAvatarType,
  user: UserAvatarUser
) => {
  return type === "firstLetter"
    ? user.name.slice(0, 1)
    : getAcronym(user.name, 2);
};

export const getUserAvatarTooltip = (user: UserAvatarUser) => {
  return user.email ? `${user.name} (${user.email})` : user.name;
};

export const getUserAvatarStatusStyle = (
  status?: UserAvatarStatusColor
): CSSProperties | undefined => {
  if (!status) return undefined;

  const statusColor = `var(--app-color-status-${status})`;

  return {
    color: "var(--app-color-white)",
    backgroundColor: statusColor,
    borderColor: statusColor,
  };
};
